export default "__VITE_ASSET__B26VnfVZ__"